import { SET_GENERATOR, SET_GENERATOR_LIST } from "./GeneratorManagementActionTypes";

const initialState = {
    generator: {},
    generators: []
}

const GeneratorManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GENERATOR:
            return { ...state, generator: action.generator };
        case SET_GENERATOR_LIST:
            return { ...state, generators: action.generators }
        default:
            return state;
    }
}

export default GeneratorManagementReducer;